// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__aime_6d62a5', '__aime_Fallback_6d62a5'"},"className":"__className_6d62a5","variable":"__variable_6d62a5"};